/**
 * Defines the type {@linkcode SubmissionV1} used for passing the I*
 * submitted pledge to the API, {@link PreprocessedSubmissionV1}
 * used for passing the preprocessed pledge to `waysact`,
 * `SubmissionResponse` used for telling the form about the status
 *o of a submission, as well as related types.
 *
 * @packageDocumentation
 */
// -------------------- Payments
export var PaymentFrequency;
(function (PaymentFrequency) {
    PaymentFrequency["OneTime"] = "oneTime";
    PaymentFrequency["Weekly"] = "weekly";
    PaymentFrequency["Fortnightly"] = "fortnightly";
    PaymentFrequency["FourWeekly"] = "fourWeekly";
    PaymentFrequency["Monthly"] = "monthly";
    PaymentFrequency["Quarterly"] = "quarterly";
    PaymentFrequency["HalfYearly"] = "halfYearly";
    PaymentFrequency["Annual"] = "annual";
})(PaymentFrequency || (PaymentFrequency = {}));
export const paymentFrequencyGuard = (key) => {
    return Object.values(PaymentFrequency).includes(key);
};
/**
 * A payment source kind. Used as a discriminator tag.
 */
export var PaymentSourceKind;
(function (PaymentSourceKind) {
    PaymentSourceKind["CreditCard"] = "creditCard";
    PaymentSourceKind["DirectDebit"] = "directDebit";
    PaymentSourceKind["ApplePay"] = "applePay";
    PaymentSourceKind["GooglePay"] = "googlePay";
    PaymentSourceKind["PayPal"] = "payPal";
    PaymentSourceKind["Stripe"] = "stripe";
})(PaymentSourceKind || (PaymentSourceKind = {}));
export var ContactConsentKind;
(function (ContactConsentKind) {
    ContactConsentKind["Phone"] = "phone";
    ContactConsentKind["SMS"] = "sms";
    ContactConsentKind["Email"] = "email";
    ContactConsentKind["Post"] = "post";
})(ContactConsentKind || (ContactConsentKind = {}));
// -------------------- Postal Address s
export var PostalAddressKind;
(function (PostalAddressKind) {
    PostalAddressKind["ApplePay"] = "ApplePay";
    PostalAddressKind["Melissa"] = "Melissa";
    PostalAddressKind["FreeForm"] = "FreeForm";
})(PostalAddressKind || (PostalAddressKind = {}));
// -------------------- Names
export var NameKind;
(function (NameKind) {
    NameKind["ApplePay"] = "ApplePay";
    NameKind["FirstLast"] = "FirstLast";
})(NameKind || (NameKind = {}));
export var FormSourceRefKind;
(function (FormSourceRefKind) {
    FormSourceRefKind["TeamMemberRef"] = "teamMemberRef";
    FormSourceRefKind["DigitalFormInstanceRef"] = "digitalFormInstanceRef";
})(FormSourceRefKind || (FormSourceRefKind = {}));
// export type IngestedSubmissionPayload = IngestedPledge;
// export interface IngestedFormSubmission {
//   campaignId: number;
//   payload: IngestedSubmissionPayload;
// }
export var SubmissionResult;
(function (SubmissionResult) {
    SubmissionResult["Success"] = "Success";
    SubmissionResult["Deferred"] = "Deferred";
    SubmissionResult["GeneralError"] = "Error";
    SubmissionResult["StripeError"] = "StripeError";
    SubmissionResult["StripeRequiresAction"] = "StripeRequiresAction";
})(SubmissionResult || (SubmissionResult = {}));
export var SubmissionErrorReason;
(function (SubmissionErrorReason) {
    SubmissionErrorReason[SubmissionErrorReason["invalidSubmissionFormat"] = 0] = "invalidSubmissionFormat";
    SubmissionErrorReason[SubmissionErrorReason["unknownCampaign"] = 1] = "unknownCampaign";
    SubmissionErrorReason[SubmissionErrorReason["internalError"] = 2] = "internalError";
})(SubmissionErrorReason || (SubmissionErrorReason = {}));
//# sourceMappingURL=pledge.js.map